import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { GetRealizedMeteringsCsvContentOfPointsRequest } from './types/getRealizedMeteringsCsvContentOfPointsRequest';

/**
 * @internal
 */
export class ApiMidbackMetering extends ApiBaseMidBack {
  @ApiOptions({ channel: 'volumeExportExcel', responseType: 'blob' })
  postExcelAsync(params: ParamsAdapter) {
    return this.post<Blob>('/metering/excel', params);
  }

  @ApiOptions({ channel: 'volumeGasSeries' })
  getMeteringRealized(params: ParamsAdapter) {
    return this.post(`/metering/realized`, params);
  }

  @ApiOptions({ responseType: 'text' })
  getMeteringRealizedCSV(params: GetRealizedMeteringsCsvContentOfPointsRequest) {
    return this.post<string>(`/metering/realized/csv`, new DefaultParams(params));
  }
}
